<mat-card class="home mat-elevation-z3">

    <mat-card-title class="title" style="padding-left: 15px;">
        CANAL DE DENÚNCIA
    </mat-card-title>

</mat-card>

<mat-divider></mat-divider>

<!-- <mat-card>

    <mat-card-subtitle class="subtitle" style="text-align: justify; padding-right: 40px; padding-left: 40px; padding-bottom: 10px;">
        Construção de uma solução onde os usuários possam fazer denúncias acerca de irregularidades e
        desvios de conduta de colaboradores e gestores da organização, sendo enviadas a qualquer
        momento por funcionários, fornecedores ou clientes (sempre assegurando anonimato ao denunciante
        que não deseja ter sua identificação divulgada).
    </mat-card-subtitle>

</mat-card> -->